import { Redirect } from 'expo-router'

export default function RaiseOrFoldEmbeddedRedirect() {
  return <Redirect href="/game/raise-or-fold" />
}
